import React from "react";

import DLSButton from "../../../dls/dls-button";
import { IDSSButtonProps } from "../../DSSFramework";

export const DSSButton = ({ id, name, children, onClick, style, variant, size, disabled, active, iconPosition, icon, className, type, dataTestId }: IDSSButtonProps) => {
    return (
        <DLSButton
            id={id}
            name={name}
            variant={variant}
            size={size}
            disabled={disabled}
            active={active}
            iconPosition={iconPosition}
            icon={icon}
            className={className}
            onClick={onClick}
            dataTestId={dataTestId}
            style={style}
            type={type}
        >
            {children}
        </DLSButton>
    );
};